import i18n from "@/i18n";
import timezones from "@/assets/timezones.json";

export const languagesOptions = [
  {
    value: "en-US",
    text: i18n.t("common.english") as string,
    icon: require("@/assets/images/flags/en.png"),
  },
  {
    value: "it-IT",
    text: i18n.t("common.italian") as string,
    icon: require("@/assets/images/flags/it.png"),
  },
  {
    value: "fr-FR",
    text: i18n.t("common.french") as string,
    icon: require("@/assets/images/flags/fr.png"),
  },
  {
    value: "es-ES",
    text: i18n.t("common.spanish") as string,
    icon: require("@/assets/images/flags/es.png"),
  },
  {
    value: "ru-RU",
    text: i18n.t("common.russian") as string,
    icon: require("@/assets/images/flags/ru.png"),
  },
];

export const timezonesOptions = timezones;
